var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00012 12C4.00012 11.4477 4.44784 11 5.00012 11H19.0001C19.5524 11 20.0001 11.4477 20.0001 12C20.0001 12.5523 19.5524 13 19.0001 13H5.00012C4.44784 13 4.00012 12.5523 4.00012 12Z",
    fill: "#90959F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7072 4.29292C13.0978 4.68345 13.0978 5.31661 12.7072 5.70714L6.41434 12L12.7072 18.2929C13.0978 18.6834 13.0978 19.3166 12.7072 19.7071C12.3167 20.0977 11.6835 20.0977 11.293 19.7071L4.29302 12.7071C3.90249 12.3166 3.90249 11.6834 4.29302 11.2929L11.293 4.29292C11.6835 3.9024 12.3167 3.9024 12.7072 4.29292Z",
    fill: "#90959F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewArrowLeft);
export default __webpack_public_path__ + "static/media/new_arrow-left.2421bef8.svg";
export { ForwardRef as ReactComponent };